import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { UserEditUseCase } from 'shared/domain/user/editUser';
import { UserEditModel } from 'shared/domain/user/types/model';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { getProjectId } from 'serviceWorker/db/config';
import { getOne as getUser } from 'serviceWorker/db/users/users';
import { debugLog } from 'shared/logger/debugLog';
import {
  UserHttpCreateRequestModel,
  UserHttpEditPermissionsRequestModel,
  UserHttpEditLabelAndPhoneRequestModel,
} from '../httpQueue/user/types';
import { createUniqueId } from 'shared/utils/id/id';

export class UserEditor implements UserEditUseCase {
  constructor(
    private addRequest: (
      request:
        | UserHttpEditLabelAndPhoneRequestModel
        | UserHttpCreateRequestModel
        | UserHttpEditPermissionsRequestModel
    ) => Promise<any>
  ) {}

  async execute(
    userEditModel: UserEditModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('UserEditUseCase', userEditModel);
    const userId = await getUser(userEditModel._id);
    if (!userId) {
      throw new Error('Cannot find user.');
    }
    if (!userEditModel.organizationId) {
      throw new Error('Cannot find client.');
    }
    const userPersonalDataUrl = `/user/${userId._id}/personalData/client/${userEditModel.organizationId}`;
    const userPermissionUrl = `/user/${userId._id}/permission`;
    const projectId = await getProjectId();
    const { label, phone, permissions } = userEditModel;
    // uniqueId cannot be used twice
    let usedUniqueId = false;
    if (permissions) {
      const permissionChangeRequest: UserHttpEditPermissionsRequestModel = {
        createdAt: Date.now(),
        method: 'PUT',
        data: {
          userEditPermissionsOutDto: { permissions },
          uniqueId,
          projectId,
        },
        url: userPermissionUrl,
        entityType: HttpRequestModelType.user,
        status: HttpRequestStatus.NEW,
      };
      await this.addRequest(permissionChangeRequest);
      usedUniqueId = true;
    }

    if (typeof label === 'string' || typeof phone === 'string') {
      debugLog('labelAndPhoneChangeRequest', label, phone);

      const labelAndPhoneChangeRequest: UserHttpEditLabelAndPhoneRequestModel =
        {
          createdAt: Date.now(),
          method: 'PUT',
          data: {
            userLabelAndPhoneEditOutDto: { label, phone },
            uniqueId: usedUniqueId ? createUniqueId() : uniqueId,
            projectId,
          },
          url: userPersonalDataUrl,
          entityType: HttpRequestModelType.user,
          status: HttpRequestStatus.NEW,
        };
      await this.addRequest(labelAndPhoneChangeRequest);
    }
  }
}

export const userEditor = new UserEditor(addRequest);
